import { render, staticRenderFns } from "./productSjList.vue?vue&type=template&id=9717da14&scoped=true"
import script from "./productSjList.vue?vue&type=script&lang=js"
export * from "./productSjList.vue?vue&type=script&lang=js"
import style0 from "./productSjList.vue?vue&type=style&index=0&id=9717da14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9717da14",
  null
  
)

export default component.exports